import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';

import { CreditPolicyActionTypes , CreditPolicyActions, LoadCreditPoliciesSuccess} from '../actions/credit-policy.actions';
import { SummaryCreditPolicyModel } from '../../models/summary-credit-policy.model';


export interface CreditPolicyState {
  items: SummaryCreditPolicyModel[];
  total: number;
  res: PaginableResponseModel<SummaryCreditPolicyModel>;
  selected: SingleResponseModel<SummaryCreditPolicyModel> | null;
  loading: boolean;
  error: any
}


export const initalState: CreditPolicyState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function CreditPolicyReducer(
  state = initalState,
  action: CreditPolicyActions
): CreditPolicyState {
  switch (action.type) {
    case CreditPolicyActionTypes.LoadCreditPolicies:
      return { ...state, loading: true, error: null };

    case CreditPolicyActionTypes.LoadCreditPoliciesSuccess:
      const { items, total } = (action as LoadCreditPoliciesSuccess).payload;

      return {
        ...state,
        loading: false,
        error: null,
        items: items,
        total: total,
      };

    case CreditPolicyActionTypes.LoadCreditPoliciesFailure:
      return { ...state, loading: false, error: action.payload.error };

    case CreditPolicyActionTypes.LoadCreditPolicySuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
